// extracted by mini-css-extract-plugin
export var modal = "_to-0";
export var table = "_to-1";